import { useContext, useEffect, useRef } from 'react'
import { AppState } from './AppState'

/**
 * @param {Boolean} shouldLimit Determine, on mount, whether the header & footer are indeed limited or not
 */
export const useLimitedHeaderFooter = (shouldLimit = true) => {
  const shouldLimitRef = useRef(shouldLimit)
  const { setFullHeaderFooter } = useContext(AppState)
  useEffect(() => {
    if (shouldLimitRef.current) {
      setFullHeaderFooter(false)
    }
    return () => {
      setFullHeaderFooter(true)
    }
  }, [setFullHeaderFooter, shouldLimitRef.current])
}
